import connect from './connect';

export { EnvelopeDetailTable } from './EnvelopeDetailTable';

export default connect;
